if (!customElements.get("m-announcement-bar")) {
  class MAnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const enableSlider = this.dataset.enableSlider === "true";
      
      const onFullLoad = () => {
        this.updateHeight();
        if (enableSlider && !this.slider) {
          this.initSlider();
        }
      };

      if (document.readyState === "complete") {
        onFullLoad();
      } else {
        window.addEventListener("load", onFullLoad, { once: true });
        document.addEventListener("DOMContentLoaded", () => {
          setTimeout(onFullLoad, 100);
        }, { once: true });
      }

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.updateHeight());
      }
    }

    updateHeight() {
      const slideContainer = this.querySelector(".swiper-container");
      const items = this.querySelectorAll(".m-announcement-bar__item");
      if (!items.length) return;

      let maxHeight = 0;
      items.forEach((item) => {
        const content = item.querySelector(".m-announcement-bar__content") || item;
        const h = content.offsetHeight || item.offsetHeight;
        if (h > maxHeight) maxHeight = h;
      });

      if (maxHeight > 0) {
        if (slideContainer) {
          slideContainer.style.height = `${maxHeight}px`;
        }
        document.documentElement.style.setProperty('--m-announcement-height', `${maxHeight}px`);
      }
    }

    initSlider() {
      if (this.slider) return;
      const autoplay = this.dataset.enableAutoplay === "true";
      const autoplaySpeed = this.dataset.autoplaySpeed;
      const slideContainer = this.querySelector(".swiper-container");
      if (slideContainer) {
        const self = this;
        this.slider = new MinimogLibs.Swiper(slideContainer, {
          direction: 'vertical',
          slidesPerView: 1,
          slidesPerGroup: 1,
          speed: 600, // Smooth bottom-to-top transition duration (600ms)
          autoplay: autoplay
            ? {
                delay: parseInt(autoplaySpeed) * 1000,
                disableOnInteraction: false,
              }
            : false,
          loop: true,
          navigation: {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          },
          on: {
            init: function () {
              requestAnimationFrame(() => {
                self.updateHeight();
                this.update();
              });
            },
            slideChange: function () {
              self.updateHeight();
            },
            resize: function () {
              self.updateHeight();
              this.update();
            }
          }
        });

        window.addEventListener("resize", () => this.updateHeight());
      }
    }
  }

  customElements.define("m-announcement-bar", MAnnouncementBar);
}
